import React from "react";

import { CloseRounded, SendRounded } from "@mui/icons-material";
import { Box, DialogContent } from "@mui/material";
import { httpsCallable } from "firebase/functions";

import { Constants } from "../../../../config/constants";
import useFirebase from "../../../../config/context/firebaseContext";
import useModal from "../../../../config/context/modalContext";
import { Dev } from "../../../../config/util/consoleUtil";

import MainSolidButton from "../../../../components/MainSolidButton";
import { ModalTransition } from "../../../../components/ModalTransition";
import PageHeader from "../../../../components/PageHeader";

import AutocompleteMain from "../../../../components/InputMain/AutocompleteMain";
import TextMain from "../../../../components/InputMain/TextMain";
import { WideDialog } from "../../../../components/MainModalSimple/styles";

import ChipMain from "../../../../components/InputMain/ChipMain";
import { ModalBaseType } from "../../../../types/common";

export default function ModalNotificationCreate({ onClose }: ModalBaseType) {
  const [open, setOpen] = React.useState(true);

  const allTopics = [...Constants.publicTopics, ...Constants.privateTopics];

  const allTopicNames = allTopics.map((item) => item.topic);

  const { pushAlert } = useModal();

  const { functions } = useFirebase();

  const [titleField, setTitleField] = React.useState("");
  const [bodyField, setBodyField] = React.useState("");
  const [topicField, setTopicField] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const handleSend = async () => {
    try {
      setLoading(true);

      const sendNotificationToTopic = httpsCallable(functions, "sendNotificationToTopic");

      const result = await sendNotificationToTopic({
        title: titleField,
        body: bodyField,
        topic: topicField,
      });

      pushAlert({
        type: "success",
        message: "Notificação Enviada",
      });

      handleClose(true);
    } catch (error) {
      console.log(...new Dev("handleSend", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao enviar notificação",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (reload?: boolean) => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose(reload);
    }, 200);
  };

  const handleDefaultMessage = (value: string | number) => {
    setTitleField("Notificação Teste");
    setBodyField("Esta é uma notificação de teste, não se preocupe.");
    setTopicField(String(value));
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={() => handleClose()}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={"Enviar Notificação"}
          rightIcon={<CloseRounded />}
          onRightAction={() => handleClose()}
        />

        <Box mb={3} gap={1} display={"flex"}>
          <ChipMain
            options={allTopics
              .map((item) => ({ ...item, value: item.topic }))
              .filter((item) => item.value.includes("general"))}
            onChange={handleDefaultMessage}
            value={"false"}
          />
        </Box>

        <Box>
          <AutocompleteMain
            name="Canal"
            value={topicField}
            options={allTopicNames}
            onChange={(value) => {
              console.log("--", value);
              setTopicField(value);
            }}
          />

          <TextMain name="Título" textColor="regular" value={titleField} onChange={setTitleField} />

          <TextMain
            name="Corpo"
            textColor="regular"
            value={bodyField}
            onChange={setBodyField}
            lines={3}
          />

          <Box my={3}>
            <MainSolidButton
              loading={loading}
              text="Enviar"
              icon={<SendRounded />}
              onClick={handleSend}
            />
          </Box>
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
